export function getMaxLengthChars(text, maxLength) {
  return text.length > maxLength ? text.slice(0, maxLength) : text;
}
export function formatDateStringFromTimestamp(timestamp) {
  const dt = new Date(timestamp);
  let mm = dt.getMonth() + 1; // Months start at 0
  let dd = dt.getDate();
  return `${mm}/${dd}`;
}

export function trimText(text, maxLength) {
  let sliced = text.slice(0, maxLength);
  if (sliced.length < text.length) {
    return sliced += '...';
  } else {
    return text;
  }
}

export function wrapLinksInText(text) {
  if (!text) return text;

  const urlRegex = /(?<!href\s*=\s*["']?)(?<!src\s*=\s*["']?)(https?:\/\/[^\s<]+)/gi;

  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

